import { OPEN_LIGHTBOX, CLOSE_LIGHTBOX, CHANGE_LIGHTBOX_INDEX } from './types';

export const openLightbox = ({ images, imgIndex }) => ({
  type: OPEN_LIGHTBOX,
  images,
  imgIndex,
});

export const closeLightbox = () => ({
  type: CLOSE_LIGHTBOX,
});

export const changeLightboxIndex = imgIndex => ({
  type: CHANGE_LIGHTBOX_INDEX,
  imgIndex,
});



// WEBPACK FOOTER //
// ./src/redux/actions/lightboxStateActions.js